import * as jAko from './jAko/modules.js';

/*#region generate MapsMulti*/
class GenerateMapsMulti {
    token = "";
    idComposant = "";
    idmap = "";

    /*#region constructor*/
    constructor(idmap, idComposant, dataAdress, idnewContain) {
        if (idComposant != null) {
            this.idComposant = idComposant.replace(/#/g, "");

            if (idmap != null) {
                this.idmap = idmap.replace(/#/g, "");

                if (dataAdress[2] != undefined || dataAdress[2] != '') {
                    this.ressourceUri = dataAdress[2];
                }
                else {
                    this.ressourceUri = '/wp-content/themes/winwin-theme/';
                }

                if (dataAdress[3] != undefined || dataAdress[2] != '') {
                    this.nameIcon = dataAdress[3];
                }
                else {
                    this.nameIcon = 'icon-maps.png';
                }

                if (dataAdress[1].length > 0) {
                    this.token = dataAdress[0];

                    if (this.carte == undefined) {
                        this.initMap(dataAdress[1], idnewContain);
                    }
                    else {
                        jQuery('.leaflet-container').remove();
                        jQuery('.leaflet-control-container').remove();
                    }

                }
                else {
                    GenerateMapsMulti.errorCloseMap("Aucune liste d'adresse", this.idComposant);
                }
            }
            else {
                GenerateMapsMulti.errorCloseMap("Problème avec l'id du composant map concerné", this.idComposant);
            }
        }
        else {
            GenerateMapsMulti.errorCloseMap("Problème avec l'id du composant map concerné", this.idComposant);
        }
    }
    /*#endregion*/

    /*#region Open street map*/
    templateWindowMap(data) {
        let htmlPopUp = "";

        if (!jAko.AkoTools.isEmpty(data)) {

            htmlPopUp += '<div class="infowindow-structure text-center">';
            if (!jAko.AkoTools.isEmpty(data.title)) {
                htmlPopUp += '<h3 class="h6 txt-silver-d">' + data.title + '</h3>';
            }

            if (!jAko.AkoTools.isEmpty(data.imgSrc)) {
                htmlPopUp += '<img class="mb-3" width="200px" src="' + data.imgSrc + '" alt=""/>';
            }
            if (!jAko.AkoTools.isEmpty(data.id)) {
                htmlPopUp += '<p><a href="?card-structure=' + data.id + '#' + this.idComposant + '" class="btn btn-positif-dark-dark btn-radius btn-select-card" >Rechercher la fiche</a></p>';
            }

            htmlPopUp += '</div>';
        }

        return htmlPopUp;
    }

    initMap(obectList, idnewContain) {

        let markers = [];

        let carte = new L.map(idnewContain).setView([47, 5.746], 8);
        this.carte = carte;
        let markerClusters = L.markerClusterGroup();

        let myIcon = L.icon(
            {
                iconUrl: this.ressourceUri + "/public/images/" + this.nameIcon,
                iconSize: [41, 60],
                iconAnchor: [20, 30],
                popupAnchor: [0, -30],
            }
        );

        L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
            {
                attribution: 'données © <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - rendu <a href="//openstreetmap.fr">OSM France</a>',
                minZoom: 1,
                maxZoom: 17
            }
        )
            .addTo(carte);

        if (!jAko.AkoTools.isEmpty(obectList && !jAko.AkoTools.isEmpty(carte))) {
            obectList.forEach(structure => {
                let lat = "";
                let long = "";
                let idStructure = "";
                let title = "";
                let referenceLink = "";
                let imgSrc = "";

                if (!jAko.AkoTools.isEmpty(structure.coord)) {
                    let coords = JSON.parse(structure.coord);

                    if (coords.features.length > 0) {
                        if (!jAko.AkoTools.isEmpty(coords.features[0].geometry.coordinates[1])) {
                            lat = coords.features[0].geometry.coordinates[1];
                        }

                        if (!jAko.AkoTools.isEmpty(coords.features[0].geometry.coordinates[0])) {
                            long = coords.features[0].geometry.coordinates[0];
                        }

                        if (!jAko.AkoTools.isEmpty(structure.title)) {
                            title = structure.title;
                        }
                        if (!jAko.AkoTools.isEmpty(structure.link)) {
                            referenceLink = structure.link;
                        }
                        if (!jAko.AkoTools.isEmpty(structure.imgSrc)) {
                            imgSrc = structure.imgSrc;
                        }
                        if (!jAko.AkoTools.isEmpty(structure.id)) {
                            idStructure = structure.id;
                        }

                        let marker = L.marker([lat, long], { icon: myIcon }).addTo(carte);
                        marker.bindPopup(this.templateWindowMap({ id: idStructure, title: title, referenceLink: referenceLink, imgSrc }));
                        markerClusters.addLayer(marker);
                        markers.push(marker);
                    }
                }
            }
            );

            var group = new L.featureGroup(markers);
            carte.fitBounds(group.getBounds().pad(0.5));
            carte.addLayer(markerClusters);
        }

        jQuery("#" + this.idComposant + "  .map-spinner").fadeOut("slow", function () {
            jQuery(this).remove();
        });
        jQuery("#mapComponentAcheter .button-collaps-map button").removeClass("disabled");
    }
    /*#endregion */

    /*#region anim collaps */
    static openMapsCollaps() {
        jQuery("#mapComponentAcheter").removeClass("close-map");
        jQuery("#mapComponentAcheter").addClass("open-map");

        jQuery("#mapComponentAcheter .button-collaps-map button").removeClass("close-map");
        jQuery("#mapComponentAcheter .button-collaps-map button").addClass("open-map");

        jQuery(".margin-colonne-map").removeClass("close-map");
        jQuery(".margin-colonne-map").addClass("open-map");

        jQuery("#mapComponentAcheter .button-collaps-map button i").removeClass("fa-chevron-right");
        jQuery("#mapComponentAcheter .button-collaps-map button i").addClass("fa-chevron-left");

        jQuery('#list-cards li').removeClass('col-xl-4');
        jQuery('#list-cards li').addClass('col-xl-6');

        jQuery("#mapComponentAcheter .button-collaps-map button").removeClass("disabled");

    }

    static closeMapsCollaps() {
        jQuery("#mapComponentAcheter").removeClass("open-map");
        jQuery("#mapComponentAcheter").addClass("close-map");

        jQuery("#mapComponentAcheter .button-collaps-map button").removeClass("open-map");
        jQuery("#mapComponentAcheter .button-collaps-map button").addClass("close-map");

        jQuery(".margin-colonne-map").removeClass("open-map");
        jQuery(".margin-colonne-map").addClass("close-map");

        jQuery("#mapComponentAcheter .button-collaps-map button i").removeClass("fa-chevron-left");
        jQuery("#mapComponentAcheter .button-collaps-map button i").addClass("fa-chevron-right");

        jQuery('#list-cards li').removeClass('col-xl-6');
        jQuery('#list-cards li').addClass('col-xl-4');
    }
    /*#endregion*/

    /*#region events */
    static startEventClickbuttonMap(dataMapJson, idComposant, idnewContain) {
        jQuery("#mapComponentAcheter .button-collaps-map button").click(function () {
            if (!jQuery(this).hasClass('disabled')) {
                if (jQuery(this).hasClass('open-map')) {
                    GenerateMapsMulti.closeMapsCollaps();
                }
                else if (jQuery(this).hasClass('close-map')) {
                    jQuery("#mapComponentAcheter .button-collaps-map button").addClass("disabled");
                    GenerateMapsMulti.openMapsCollaps(dataMapJson, idComposant, idnewContain);
                }
            }
        }
        );
    }
    /*#endregion*/

    /*#region errors */
    static errorCloseMap(message = "Une erreur est survenue", idComposant = "") {
        console.log(message);
        jQuery("#" + idComposant).remove();
        GenerateMapsMulti.closeMapsCollaps();

        let margeColonne = document.getElementsByClassName("margin-colonne-map");
        if (margeColonne != undefined || margeColonne != null) {
            if (margeColonne.length > 0) {
                if (margeColonne[0].classList != undefined && margeColonne[0].classList.length > 0) {
                    margeColonne[0].classList.remove("close-map");
                }
            }
        }
    }
    /*#endregion*/

}
/*#endregion*/

/*#region main */
jQuery(document).ready(function () {
    if (jQuery("#map-init") != undefined) {
        var w = 0;
        var mapName = idnewContain;
        var component = document.getElementById(idComposant);
        var internet = navigator.onLine;

        if (component != null && internet === true && dataMapJson != null) {
            jQuery("#mapComponentAcheter .button-collaps-map button").addClass("disabled");
            GenerateMapsMulti.openMapsCollaps(dataMapJson, idComposant, idnewContain);
            GenerateMapsMulti.startEventClickbuttonMap(dataMapJson, idComposant, idnewContain);

            var div = document.createElement("div");
            div.setAttribute("id", mapName);
            div.setAttribute("class", "");
            div.setAttribute("style", "");
            component.appendChild(div);

            setTimeout(function () {
                try {
                    new GenerateMapsMulti("#" + mapName, "#" + idComposant, dataMapJson, idnewContain);

                    window.addEventListener('resize', function () {
                        w = window.innerWidth;
                        if (w < 991) {
                            jQuery('#mapComponentAcheter button span').removeClass('sr-only');
                        }
                        else {
                            jQuery('#mapComponentAcheter button span').addClass('sr-only');
                        }
                    });
                }
                catch (er) {
                    GenerateMapsMulti.errorCloseMap(er, idComposant);
                }
            },
                300);
        }
        else {
            GenerateMapsMulti.errorCloseMap("problème avec la connexion internet", idComposant);
        }
    }
}
);

/*#endregion*/